module.exports = __webpack_public_path__ + "static/media/tripadvisor.d7d61fb4.png";